import { types } from 'mobx-state-tree'
import { editableModel } from '@linqpal/models'
import makeInspectable from 'mobx-devtools-mst'

export const Source = {
  PAYABLES: 'payables',
  INVOICE_LINK: 'invoiceLink',
}

const props = {
  modal: types.optional(types.string, ''),
  chosenMethodTypeFromInvoice: types.optional(types.string, ''),
  history: types.optional(types.array(types.string), []),
}

function views(self) {
  return {
    get showAddBank() {
      return self.modal === 'addBank'
    },
    get showAddPaymentMethod() {
      return self.modal === 'addPaymentMethod'
    },
    get showListMethods() {
      return self.modal === 'listMethods'
    },
    get isChosenMethodTypeFromInvoiceBank() {
      return self.chosenMethodTypeFromInvoice === 'bank'
    },
    get isChosenMethodTypeFromInvoiceCard() {
      return self.chosenMethodTypeFromInvoice === 'card'
    },
    get canGoBack() {
      return !!self.history.length
    },
  }
}

function actions(self) {
  return {
    setModal(type: string, saveHistory?: boolean) {
      saveHistory && self.modal && self.addToHistory(self.modal)
      self.modal = type
    },
    setChosenMethodTypeFromInvoice(type: string) {
      self.chosenMethodTypeFromInvoice = type
    },
    reset() {
      self.setChosenMethodTypeFromInvoice('')
      self.setModal('')
    },
    addingFromInvoice(source) {
      return source === Source.PAYABLES || source === Source.INVOICE_LINK
    },
    addToHistory(modalName) {
      self.history.push(modalName)
    },
    getPrevious() {
      return self.history.pop()
    },
  }
}

export const AddPaymentMethodStoreModel = types
  .compose(types.model(props).views(views).actions(actions), editableModel())
  .named('AddPaymentMethodStore')
const store = AddPaymentMethodStoreModel.create({})
makeInspectable(store)
export default store
